const activeLabelStyles = {
    transform: 'scale(0.85) translateY(-24px)',
    color: 'black'
}

const activeLabelStylesProfile = {
    transform: 'scale(0.85) translateY(-14px)',
    color: 'black',
    fontSize: 'xs',
    lineHeight: 'normal'
}

const disabledLabelStyles = {
    transform: 'scale(0.85) translateY(-14px)',
    color: 'gray.700'
}

export default {
    variants: {
        floating: {
            container: {
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    ...activeLabelStyles
                },
                '&:has(input:-webkit-autofill) label': {
                    ...activeLabelStyles
                },
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        ...activeLabelStyles
                    },
                label: {
                    top: 0,
                    left: 0,
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    pointerEvents: 'none',
                    mx: 0,
                    px: 0,
                    my: 2,
                    transformOrigin: 'left top',
                    transition: 'all 0.2s ease-in-out',
                    color: 'gray.700'
                }
            }
        },
        floatingGrayed: {
            container: {
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    ...disabledLabelStyles
                },
                '&:has(input:-webkit-autofill) label': {
                    ...disabledLabelStyles
                },
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        ...disabledLabelStyles
                    },
                label: {
                    fontSize: 'xs',
                    top: '6px',
                    left: '4px',
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    pointerEvents: 'none',
                    mx: 0,
                    px: 0,
                    my: 2,
                    transformOrigin: 'left top',
                    transition: 'all 0.2s ease-in-out',
                    color: 'gray.700',
                    lineHeight: 'normal'
                },
                input: {
                    height: '50px',
                    fontSize: 'md',
                    paddingLeft: '4px',
                    paddingTop: '10px'
                }
            }
        },
        floatingProfileForm: {
            container: {
                '&:has(input:focus, select:focus, textarea:focus) label': {
                    ...activeLabelStylesProfile
                },
                '&:has(input:-webkit-autofill) label': {
                    ...activeLabelStylesProfile
                },
                "&:has(input:not(:placeholder-shown), select:not([value='']), textarea:not(:placeholder-shown)) label":
                    {
                        ...activeLabelStylesProfile
                    },
                label: {
                    fontSize: 'md',
                    top: '6px',
                    left: '4px',
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    pointerEvents: 'none',
                    mx: 0,
                    px: 0,
                    my: 2,
                    transformOrigin: 'left top',
                    transition: 'all 0.2s ease-in-out',
                    color: 'gray.700',
                },
                input: {
                    height: '50px',
                    fontSize: 'md',
                    paddingLeft: '4px',
                    paddingTop: '10px'
                }
            }
        }
    }
}
